export enum MediaType {
  Tts = 'tts',
  Upload = 'upload',
  Url = 'url',
  Recording = 'recording',
  BuiltIn = 'built_in',
  Custom = 'custom',
  Existing = 'existing',
}
